
function initCustomSection() {
  // 1. Tab Switching Logic
  const tabs = document.querySelectorAll(".tab-link");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      const target = this.getAttribute("data-tab");
      
      // Update UI Classes
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("show"));
      
      this.classList.add("active");
      const targetContent = document.getElementById(target);
      if (targetContent) {
        targetContent.classList.add("show");
      }
    });
  });

  // 2. Updated YouTube Click-to-Play Logic
  const videoWrappers = document.querySelectorAll('.js-video-wrapper');

  videoWrappers.forEach(wrapper => {
    // We listen for the click on the whole container for better UX
    wrapper.addEventListener('click', function() {
      // Prevent reloading if already playing
      if (this.classList.contains('is-playing')) return;

      const videoId = this.getAttribute('data-video-id');
      const placeholder = this.querySelector('.iframe-placeholder');
      
      // Inject the YouTube Iframe
      placeholder.innerHTML = `
        <iframe 
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>`;
      
      // Add class to hide the cover image via CSS
      this.classList.add('is-playing');
    });
  });
}

// Ensure it runs on page load and when editing in Shopify Theme Customizer
document.addEventListener("DOMContentLoaded", initCustomSection);
document.addEventListener("shopify:section:load", initCustomSection);




const items = document.querySelectorAll('.accordion button');

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }

  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}

items.forEach((item) => item.addEventListener('click', toggleAccordion));



